var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialProps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1271,
    height: 209,
    viewBox: "0 0 1271 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1224.8 196.57C1224.05 196.569 1223.32 196.342 1222.7 195.916C1222.08 195.491 1221.6 194.888 1221.33 194.187C1216.86 182.565 1216.55 172.537 1220.4 164.376C1223.4 158.151 1228.66 153.303 1235.11 150.817C1236.03 150.535 1237.03 150.625 1237.89 151.068C1238.75 151.511 1239.41 152.271 1239.72 153.188C1240.02 154.105 1239.96 155.105 1239.55 155.978C1239.13 156.851 1238.39 157.526 1237.48 157.862C1232.92 159.727 1229.21 163.213 1227.07 167.649C1224.17 173.889 1224.58 181.921 1228.27 191.521C1228.48 192.083 1228.56 192.69 1228.49 193.289C1228.42 193.888 1228.21 194.461 1227.86 194.958C1227.52 195.455 1227.07 195.862 1226.53 196.143C1226 196.424 1225.4 196.57 1224.8 196.57V196.57Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.14 187.448C1200.39 187.448 1199.66 187.221 1199.04 186.795C1198.42 186.37 1197.95 185.767 1197.68 185.066C1193.21 173.449 1192.89 163.416 1196.74 155.254C1199.74 149.03 1205 144.183 1211.45 141.701C1212.39 141.386 1213.41 141.455 1214.29 141.893C1215.17 142.331 1215.84 143.101 1216.16 144.035C1216.47 144.968 1216.4 145.989 1215.96 146.871C1215.53 147.754 1214.76 148.426 1213.82 148.741C1209.26 150.606 1205.56 154.095 1203.42 158.533C1200.52 164.773 1200.92 172.8 1204.61 182.399C1204.83 182.962 1204.9 183.569 1204.83 184.168C1204.76 184.767 1204.55 185.34 1204.21 185.837C1203.87 186.334 1203.41 186.741 1202.87 187.021C1202.34 187.302 1201.75 187.449 1201.14 187.448Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.85 166.914L1189.85 147.753L1208.03 75L1245.02 94.1662L1226.85 166.914Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.03 75L1242.56 78.2087L1269.72 91.4565L1245.02 94.1662L1208.03 75Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1269.72 91.4565L1253.51 162.611L1226.85 166.914L1245.02 94.1662L1269.72 91.4565Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.15 101.667L1239.24 129.859L1248.16 129.311L1240.66 151.955L1257.74 120.603L1248.81 121.15L1254.15 101.667Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.96 104.604C1231.53 98.3193 1229.15 92.3119 1224.64 91.1862C1220.14 90.0604 1215.21 94.2426 1213.64 100.527C1212.07 106.812 1214.45 112.819 1218.96 113.945C1223.46 115.071 1228.39 110.889 1229.96 104.604Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.49 103.548C1227.59 99.1489 1225.93 94.9441 1222.77 94.156C1219.62 93.3679 1216.17 96.2949 1215.07 100.694C1213.97 105.092 1215.64 109.297 1218.79 110.085C1221.95 110.873 1225.4 107.946 1226.49 103.548Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.7 102.845C1224.35 100.255 1223.36 97.7784 1221.51 97.3143C1219.65 96.8502 1217.62 98.5739 1216.97 101.164C1216.33 103.755 1217.31 106.231 1219.16 106.695C1221.02 107.159 1223.05 105.435 1223.7 102.845Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.17 98.9575L1219.9 101.453L1216.6 103.652",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.99 138.804C1227.37 129.293 1223.77 120.203 1216.95 118.499C1210.13 116.796 1202.68 123.125 1200.3 132.635C1197.93 142.146 1201.53 151.236 1208.34 152.94C1215.16 154.643 1222.61 148.314 1224.99 138.804Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.16 137.656C1221.83 130.998 1219.31 124.634 1214.53 123.441C1209.76 122.248 1204.54 126.679 1202.88 133.338C1201.22 139.996 1203.74 146.361 1208.51 147.553C1213.28 148.746 1218.5 144.315 1220.16 137.656Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.59 136.091C1216.57 132.169 1215.09 128.421 1212.28 127.719C1209.47 127.017 1206.4 129.627 1205.42 133.549C1204.44 137.47 1205.92 141.218 1208.73 141.92C1211.54 142.622 1214.61 140.012 1215.59 136.091Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.72 130.218L1209.86 133.995L1204.19 137.156",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.53 79.796C1210.78 78.9521 1210.51 78.1289 1209.93 77.9574C1209.35 77.7859 1208.68 78.331 1208.43 79.175C1208.18 80.019 1208.44 80.8421 1209.02 81.0136C1209.6 81.1851 1210.28 80.64 1210.53 79.796Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.85 96.9088C1243.1 96.0649 1242.83 95.2417 1242.25 95.0702C1241.67 94.8987 1241 95.4438 1240.75 96.2878C1240.5 97.1318 1240.76 97.9549 1241.34 98.1264C1241.92 98.2979 1242.6 97.7528 1242.85 96.9088Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.31 146.336C1194.56 145.492 1194.29 144.669 1193.72 144.497C1193.14 144.326 1192.46 144.871 1192.21 145.715C1191.96 146.559 1192.23 147.382 1192.81 147.554C1193.39 147.725 1194.06 147.18 1194.31 146.336Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.63 163.455C1226.88 162.611 1226.61 161.788 1226.03 161.616C1225.45 161.445 1224.78 161.99 1224.53 162.834C1224.28 163.678 1224.55 164.501 1225.13 164.672C1225.71 164.844 1226.38 164.299 1226.63 163.455Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7768 196.57C47.5282 196.569 48.262 196.342 48.8816 195.916C49.5012 195.491 49.9776 194.888 50.2483 194.187C54.7179 182.565 55.0292 172.537 51.1766 164.376C48.1759 158.151 42.917 153.303 36.4693 150.817C35.5439 150.535 34.5453 150.625 33.6853 151.068C32.8253 151.511 32.1717 152.271 31.8631 153.188C31.5545 154.105 31.6153 155.105 32.0325 155.978C32.4497 156.851 33.1905 157.526 34.0977 157.862C38.6568 159.727 42.3646 163.213 44.5071 167.649C47.4045 173.889 47.0021 181.921 43.3105 191.521C43.0935 192.083 43.0168 192.69 43.0871 193.289C43.1574 193.888 43.3724 194.461 43.7137 194.958C44.055 195.455 44.5123 195.862 45.046 196.143C45.5797 196.424 46.1737 196.57 46.7768 196.57V196.57Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4344 187.448C71.1853 187.448 71.9185 187.221 72.5374 186.795C73.1562 186.37 73.6315 185.767 73.9006 185.066C78.3702 173.449 78.6868 163.416 74.8343 155.254C71.8342 149.03 66.5749 144.183 60.127 141.701C59.1934 141.386 58.1732 141.455 57.2907 141.893C56.4082 142.331 55.7358 143.101 55.4213 144.035C55.1068 144.968 55.176 145.989 55.6137 146.871C56.0515 147.754 56.8218 148.426 57.7553 148.741C62.3145 150.606 66.0209 154.095 68.1594 158.533C71.0622 164.773 70.6598 172.8 66.9682 182.399C66.7512 182.962 66.6745 183.569 66.7448 184.168C66.815 184.767 67.0301 185.34 67.3714 185.837C67.7127 186.334 68.17 186.741 68.7037 187.021C69.2373 187.302 69.8314 187.449 70.4344 187.448Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7327 166.914L81.7236 147.753L63.5501 75L26.5592 94.1662L44.7327 166.914Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5498 75L29.0217 78.2087L1.85534 91.4565L26.5589 94.1662L63.5498 75Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85536 91.4565L18.065 162.611L44.7324 166.914L26.5589 94.1662L1.85536 91.4565Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4316 101.667L32.3428 129.859L23.4143 129.311L30.9209 151.955L13.8366 120.603L22.7651 121.15L17.4316 101.667Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6214 104.604C40.0509 98.3188 42.4299 92.3115 46.935 91.1857C51.4401 90.0599 56.3653 94.2421 57.9358 100.527C59.5062 106.812 57.1272 112.819 52.6221 113.945C48.117 115.07 43.1918 110.888 41.6214 104.604Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0838 103.547C43.9846 99.1484 45.6502 94.9436 48.8041 94.1555C51.9579 93.3674 55.4057 96.2944 56.5049 100.693C57.6041 105.092 55.9384 109.297 52.7845 110.085C49.6307 110.873 46.183 107.946 45.0838 103.547Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8806 102.844C47.2333 100.254 48.2142 97.7779 50.0714 97.3138C51.9287 96.8497 53.959 98.5734 54.6063 101.164C55.2536 103.754 54.2727 106.23 52.4155 106.694C50.5583 107.158 48.5279 105.435 47.8806 102.844Z",
    fill: "#231F20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4122 98.9575L51.6757 101.453L54.9756 103.652",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5881 138.804C44.2116 129.293 47.811 120.203 54.6276 118.499C61.4441 116.796 68.8966 123.125 71.2731 132.635C73.6496 142.146 70.0502 151.236 63.2337 152.94C56.4171 154.643 48.9647 148.314 46.5881 138.804Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4147 137.656C49.7508 130.998 52.2709 124.634 57.0433 123.441C61.8158 122.248 67.0335 126.679 68.6973 133.338C70.3611 139.996 67.8411 146.361 63.0686 147.553C58.2962 148.746 53.0785 144.315 51.4147 137.656Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9837 136.091C55.0037 132.169 56.4864 128.421 59.2952 127.719C62.1041 127.017 65.1755 129.627 66.1554 133.549C67.1353 137.47 65.6527 141.218 62.8438 141.92C60.0349 142.622 56.9636 140.012 55.9837 136.091Z",
    fill: "#231F20"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8575 130.218L61.7206 133.995L67.3867 137.156",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0532 79.796C60.8035 78.9521 61.071 78.1289 61.6507 77.9574C62.2304 77.7859 62.9027 78.331 63.1524 79.175C63.4021 80.019 63.1346 80.8421 62.5549 81.0136C61.9752 81.1851 61.3029 80.64 61.0532 79.796Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7328 96.9088C28.4832 96.0649 28.7507 95.2417 29.3304 95.0702C29.9101 94.8987 30.5824 95.4438 30.8321 96.2878C31.0818 97.1318 30.8142 97.9549 30.2345 98.1264C29.6548 98.2979 28.9825 97.7528 28.7328 96.9088Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2651 146.336C77.0154 145.492 77.2829 144.669 77.8626 144.497C78.4423 144.326 79.1147 144.871 79.3643 145.715C79.614 146.559 79.3465 147.382 78.7668 147.554C78.1871 147.725 77.5147 147.18 77.2651 146.336Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9467 163.455C44.697 162.611 44.9646 161.788 45.5443 161.616C46.124 161.445 46.7963 161.99 47.046 162.834C47.2956 163.678 47.0281 164.501 46.4484 164.672C45.8687 164.844 45.1964 164.299 44.9467 163.455Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.72,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M690.955 104.296C681.961 88.0318 687.51 63.0495 687.51 63.0495C674.947 68.8241 671.676 84.5507 671.676 84.5507C673.099 40.4427 646.079 21.5831 646.079 21.5831C651.711 44.6712 639.153 58.7903 633.752 63.6229C633.138 60.8226 632.329 57.7203 631.274 54.2802C624.379 31.8473 630.041 28.6273 630.425 28.4635C619.162 33.4343 612.046 47.5687 608.314 57.2954C607.562 55.7596 606.707 54.1829 605.714 52.4833C591.113 27.5061 605.202 3 605.202 3C605.202 3 584.607 23.4107 589.782 52.3502C591.876 64.0785 591.221 71.5322 589.7 76.2625C584.955 63.7611 571.552 59.7681 571.552 59.7681C580.562 74.8035 575.929 92.977 568.271 111.074C549.816 154.752 580.409 178.413 580.409 178.413L699.387 139.343C699.387 139.343 700.185 120.98 690.955 104.296Z",
    fill: "#FFDE00",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M633.496 208.023C669.541 208.023 698.762 178.803 698.762 142.757C698.762 106.712 669.541 77.4912 633.496 77.4912C597.45 77.4912 568.229 106.712 568.229 142.757C568.229 178.803 597.45 208.023 633.496 208.023Z",
    fill: "#FF2BFF",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M601.689 85.5596C601.689 85.5596 683.527 85.4367 691.579 171.84",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M652.361 80.2095C652.361 80.2095 665.717 92.0504 651.301 101.378C636.885 110.705 580.393 101.603 568.69 135.35",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M647.891 206.575C647.891 206.575 665.808 183.205 657.914 140.024C650.02 96.8421 672.668 98.982 687.427 106.615",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M671.737 90.6069C671.737 90.6069 626.794 117.227 599.411 197.534",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M709.42 114.196L648.982 119.418L648.408 119.464L587.97 124.686C587.97 125.449 588.011 126.222 588.077 126.989C588.75 134.68 592.294 141.835 598.004 147.03C603.713 152.225 611.17 155.081 618.889 155.027C626.609 154.973 634.025 152.015 639.662 146.741C645.299 141.467 648.743 134.263 649.309 126.565C651.174 134.067 655.8 140.591 662.263 144.833C668.726 149.075 676.551 150.724 684.176 149.451C691.801 148.178 698.666 144.077 703.401 137.965C708.135 131.853 710.391 124.181 709.717 116.479C709.646 115.706 709.538 114.949 709.42 114.196Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M616.516 119.219L609.241 141.831L618.743 140.776L614.673 159.774L623.586 159.641L629.99 132.314L621.19 133.466L626.335 116.408",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M616.516 119.219L609.241 141.831L618.743 140.776L614.673 159.774L623.586 159.641L629.99 132.314L621.19 133.466L626.335 116.408",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M675.879 112.62L668.604 135.237L678.101 134.177L674.031 153.175L682.944 153.042L689.348 125.72L680.548 126.867L685.693 109.814",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M675.879 112.62L668.604 135.237L678.101 134.177L674.031 153.175L682.944 153.042L689.348 125.72L680.548 126.867L685.693 109.814",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M709.42 114.196L648.982 119.418L648.408 119.464L587.97 124.686C587.97 125.449 588.011 126.222 588.077 126.989C588.75 134.68 592.294 141.835 598.004 147.03C603.713 152.225 611.17 155.081 618.889 155.027C626.609 154.973 634.025 152.015 639.662 146.741C645.299 141.467 648.743 134.263 649.309 126.565C651.174 134.067 655.8 140.591 662.263 144.833C668.726 149.075 676.551 150.724 684.176 149.451C691.801 148.178 698.666 144.077 703.401 137.965C708.135 131.853 710.391 124.181 709.717 116.479C709.646 115.706 709.538 114.949 709.42 114.196Z",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M584.929 120.012C584.929 120.012 596.022 118.988 596.647 107.398C596.647 107.398 598.618 118.701 610.013 118.558C610.013 118.558 598.782 120.176 598.121 131.177C598.121 131.177 596.242 119.956 584.929 120.012Z",
    fill: "white",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.82 139.952L917.253 98.7628L903.56 88.0906C900.655 85.8361 897.297 84.2345 893.717 83.3952C890.136 82.5558 886.417 82.4982 882.812 83.2266C879.207 83.9549 875.802 85.4519 872.828 87.6155C869.854 89.7792 867.382 92.5586 865.58 95.7643V95.7643C862.656 100.969 861.645 107.033 862.722 112.905C863.798 118.777 866.895 124.087 871.475 127.917L889.078 142.643L1000.18 187.607L1018.56 192.73C1024.35 194.338 1030.52 193.861 1035.98 191.38C1041.45 188.9 1045.88 184.575 1048.48 179.162L1048.65 178.795C1050.29 175.372 1051.15 171.625 1051.17 167.828C1051.18 164.031 1050.35 160.279 1048.73 156.844C1047.11 153.409 1044.75 150.377 1041.81 147.969C1038.88 145.56 1035.44 143.836 1031.76 142.92L1019.82 139.952Z",
    fill: "#38ECFE",
    stroke: "#211E1F",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M911.8 116.751L895.469 107.641L885.18 117.162L900.62 132.215",
    fill: "#211E1F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.72 162.598L990.384 153.496L980.095 163.017L995.535 178.07",
    fill: "#211E1F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M904.448 150.032L902.036 149.502C902.106 147.803 901.855 146.106 901.296 144.5C899.173 138.338 893.2 134.804 888.005 136.605L887.714 136.726L886.861 135.968L884.707 138.68C883.993 139.612 883.33 140.584 882.723 141.59C881.424 144.579 881.316 147.952 882.422 151.018C884.553 157.179 890.519 160.714 895.713 158.912C897.082 158.436 898.309 157.621 899.278 156.543L904.448 150.032Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M899.483 154.186C904.698 152.386 907.2 145.932 905.073 139.772C902.946 133.612 896.994 130.077 891.78 131.878C886.565 133.679 884.063 140.132 886.19 146.292C888.317 152.453 894.269 155.987 899.483 154.186Z",
    fill: "white",
    stroke: "#211E1F",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M897.035 147.098C898.935 146.442 899.846 144.09 899.071 141.844C898.295 139.599 896.127 138.31 894.227 138.966C892.327 139.622 891.416 141.974 892.191 144.22C892.967 146.465 895.135 147.754 897.035 147.098Z",
    fill: "#211E1F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M917.293 117.024L895.637 143.031",
    stroke: "#211E1F",
    strokeWidth: 10.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.48 192.88L999.061 192.358C999.133 190.656 998.884 188.957 998.328 187.348C996.197 181.194 990.232 177.659 985.037 179.453L984.738 179.574L983.885 178.816L981.732 181.536C981.013 182.465 980.35 183.437 979.747 184.445C978.448 187.432 978.341 190.802 979.446 193.866C981.569 200.028 987.543 203.562 992.737 201.768C994.103 201.284 995.328 200.47 996.303 199.398L1001.48 192.88Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M996.507 197.046C1001.72 195.245 1004.22 188.792 1002.1 182.631C999.97 176.471 994.018 172.937 988.804 174.737C983.589 176.538 981.087 182.991 983.214 189.152C985.341 195.312 991.293 198.846 996.507 197.046Z",
    fill: "white",
    stroke: "#211E1F",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M994.06 189.957C995.96 189.301 996.871 186.949 996.096 184.703C995.32 182.458 993.152 181.169 991.252 181.825C989.352 182.481 988.441 184.834 989.216 187.079C989.991 189.325 992.16 190.613 994.06 189.957Z",
    fill: "#211E1F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.74 157.874L994.073 183.881",
    stroke: "#211E1F",
    strokeWidth: 10.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M927.329 123.043L924.917 122.52C924.99 120.819 924.741 119.119 924.184 117.51C922.054 111.349 916.088 107.814 910.894 109.616L910.595 109.737L909.742 108.978L907.588 111.698C906.868 112.626 906.203 113.595 905.596 114.601C904.297 117.59 904.19 120.963 905.295 124.029C907.418 130.191 913.392 133.725 918.578 131.924C919.947 131.446 921.176 130.634 922.152 129.561L927.329 123.043Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M922.369 127.205C927.583 125.405 930.086 118.951 927.959 112.791C925.832 106.631 919.88 103.096 914.666 104.897C909.451 106.698 906.949 113.151 909.076 119.311C911.203 125.472 917.155 129.006 922.369 127.205Z",
    fill: "white",
    stroke: "#211E1F",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M919.922 120.117C921.821 119.461 922.733 117.109 921.957 114.863C921.182 112.618 919.013 111.329 917.114 111.985C915.214 112.641 914.302 114.993 915.078 117.239C915.853 119.484 918.022 120.773 919.922 120.117Z",
    fill: "#211E1F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.77 163.892L1023.36 163.362C1023.43 161.664 1023.18 159.967 1022.62 158.36C1020.5 152.199 1014.52 148.664 1009.33 150.466L1009.03 150.587L1008.17 149.829L1006.02 152.541C1005.3 153.472 1004.64 154.443 1004.03 155.451C1002.73 158.44 1002.62 161.813 1003.73 164.879C1005.85 171.041 1011.83 174.575 1017.02 172.774C1018.4 172.301 1019.63 171.485 1020.61 170.403L1025.77 163.892Z",
    fill: "#59BDED",
    stroke: "#211E1F",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.8 168.05C1026.02 166.249 1028.52 159.795 1026.39 153.635C1024.27 147.475 1018.31 143.941 1013.1 145.741C1007.88 147.542 1005.38 153.995 1007.51 160.156C1009.64 166.316 1015.59 169.85 1020.8 168.05Z",
    fill: "white",
    stroke: "#211E1F",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.36 160.961C1020.25 160.305 1021.17 157.953 1020.39 155.707C1019.62 153.462 1017.45 152.173 1015.55 152.829C1013.65 153.485 1012.74 155.837 1013.51 158.083C1014.29 160.328 1016.46 161.617 1018.36 160.961Z",
    fill: "#211E1F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M938.431 129.665L953.069 136.121L963.728 124.197L962.113 140.107L976.744 146.564L961.108 149.944L959.493 165.854L951.446 152.032L935.818 155.411L946.478 143.487L938.431 129.665Z",
    fill: "#FF3351",
    stroke: "#211E1F",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.62 139.448C1044.62 139.448 1055.26 137.99 1055.35 126.781C1055.35 126.781 1057.75 137.579 1068.72 136.935C1068.72 136.935 1057.97 138.986 1057.83 149.618C1057.83 149.618 1055.52 138.892 1044.62 139.448Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M352.32 183.495C351.275 183.843 350.22 184.194 349.154 184.548C310.605 196.687 302.016 188.357 300.689 186.565L300.541 186.365L300.306 186.443C286.955 190.522 272.185 185.309 271.992 185.234C271.889 185.066 262.168 167.905 263.414 143.088C264.387 123.995 283.377 113.179 291.496 109.417L291.721 109.342L291.71 109.102C291.602 107.286 292.111 105.486 293.153 103.995C294.196 102.503 295.712 101.408 297.455 100.885L297.805 100.769C303.879 98.9699 306.763 102.67 307.274 103.422L307.418 103.63L307.653 103.552C321.303 99.9351 339.694 98.4846 349.806 112.162C363.258 130.317 366.668 144.761 367.389 148.744L367.445 149.051L367.758 149.034C394.252 147.488 400.324 149.977 400.765 152.331C400.941 153.752 391.81 170.365 352.32 183.495Z",
    fill: "#FFDE00",
    stroke: "#211E1F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M296.312 107.393C296.312 107.393 264.695 117.906 263.414 143.053C262.133 168.201 271.992 185.2 271.992 185.2C271.992 185.2 286.903 190.627 300.555 186.337L285.897 140.77C285.897 140.77 280.719 123.699 296.312 107.393Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M367.506 148.99C397.336 147.235 400.45 150.649 400.743 152.281C401.036 153.912 391.235 171.269 349.156 184.519C307.078 197.768 300.556 186.337 300.556 186.337C370.311 167.842 367.584 149.956 367.584 149.956C367.584 149.956 365.963 133.931 349.779 112.113C333.595 90.2958 296.286 107.401 296.286 107.401C296.286 107.401 316.47 103.405 323.362 111.499",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M291.708 109.167C291.573 107.268 292.109 105.382 293.221 103.837C294.334 102.292 295.953 101.187 297.797 100.714C304.554 98.7165 307.343 103.475 307.343 103.475",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M333.884 158.498L312.806 135.657L334.085 141.74L329.697 120.815L343.229 135.462L346.235 120.37L355.271 145.608C355.271 145.608 350.64 154.853 333.884 158.498Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M314.083 138.644C312.528 139.161 310.848 138.319 310.331 136.764C309.814 135.209 310.655 133.529 312.211 133.012C313.766 132.495 315.446 133.336 315.963 134.892C316.48 136.447 315.638 138.127 314.083 138.644Z",
    fill: "#5CBCEA",
    stroke: "#201D1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M330.811 123.45C329.256 123.967 327.576 123.126 327.059 121.571C326.541 120.016 327.383 118.336 328.938 117.819C330.493 117.302 332.173 118.143 332.69 119.698C333.207 121.253 332.366 122.933 330.811 123.45Z",
    fill: "#5CBCEA",
    stroke: "#201D1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M347.174 123.788C345.737 124.266 344.153 123.392 343.636 121.837C343.119 120.282 343.865 118.634 345.302 118.156C346.738 117.678 348.323 118.552 348.84 120.107C349.357 121.662 348.611 123.31 347.174 123.788Z",
    fill: "#5CBCEA",
    stroke: "#201D1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M329.134 147.32L332.664 152.876L337.963 153.214L335.484 148.289L329.134 147.32Z",
    fill: "#5CBCEA",
    stroke: "#201D1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M345.07 148.606L339.607 146.222L339.107 139.101L345.075 142.721L345.07 148.606Z",
    fill: "#5CBCEA",
    stroke: "#201D1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M350.906 145.36L347.908 141.402L349.369 136.53L351.775 140.4L350.906 145.36Z",
    fill: "#5CBCEA",
    stroke: "#201D1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M345.722 182.023C340.843 183.645 336.474 183.719 335.965 182.187C335.456 180.654 338.998 178.097 343.877 176.475C348.756 174.853 353.124 174.78 353.633 176.312C354.143 177.844 350.601 180.401 345.722 182.023Z",
    fill: "#FF2BFF",
    stroke: "#211E1F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M296.94 138.038C296.94 138.038 288.588 145.514 279.609 137.999C279.609 137.999 286.582 147.208 278.651 155.497C278.651 155.497 287.549 148.337 296.1 155.403C296.099 155.416 289.133 146.331 296.94 138.038Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialProps);
export default __webpack_public_path__ + "static/media/socialProps.c4496d42cda2fec8d9ccf05abb04b291.svg";
export { ForwardRef as ReactComponent };